import { useState } from "react";

const CustomTableItem = ({ data, content }) => {

  return (
    <>
      <div className="tw-border-solid tw-border-[1px] tw-border-[#e3eef2] tw-rounded-md tw-shadow-md tw-px-2">
        {content}
      </div>
    </>
  );
};

export default CustomTableItem;